import { useTranslation } from 'react-i18next';
import CountryLabel from '../../../components/CountryLabel/CountryLabel';
import { Column, Table } from '../../../components/Table/Table';
import { formatDate, formatNumber } from '../../../core/helpers';
import './SingleItemTab.scss';

interface LocalFilingItem {
  country: string;
  since: Date;
  price: { amount: number; filing_frequency: 'month' | 'quarter' };
}

const getLocalFilingColumns: (
  t: (str: string) => string
) => Column<LocalFilingItem>[] = (t: (str: string) => string) => [
  {
    label: 'Country',
    field: 'country',
    formatter: (item) => <CountryLabel country={item.country} link={true} />,
    maxWidth: '160px',
  },
  {
    label: 'Status',
    field: 'since',
    formatter: (item) => (
      <div>
        {t('since')}&nbsp;
        {formatDate(item.since, 'dd.MM.yyyy')}
      </div>
    ),
    maxWidth: '2fr',
  },
  {
    label: 'Price',
    field: 'price',
    formatter: (item) => (
      <div>
        {formatNumber(item.price.amount / 100, {
          currency: 'eur',
        })}{' '}
        / {t('month')}
      </div>
    ),
  },
];

const LOCAL_FILING_ITEMS: LocalFilingItem[] = [
  {
    country: 'PL',
    since: new Date(2022, 2, 1),
    price: { amount: 8900, filing_frequency: 'month' },
  },
  {
    country: 'CZ',
    since: new Date(2022, 2, 1),
    price: { amount: 8900, filing_frequency: 'month' },
  },
  {
    country: 'IT',
    since: new Date(2022, 2, 1),
    price: { amount: 8900, filing_frequency: 'quarter' },
  },
  {
    country: 'AT',
    since: new Date(2022, 2, 1),
    price: { amount: 8900, filing_frequency: 'quarter' },
  },
  {
    country: 'ES',
    since: new Date(2022, 2, 1),
    price: { amount: 8900, filing_frequency: 'month' },
  },
];

const OTHER_DETAILS = [
  {
    title: 'OSS filing',
    country: 'DE',
    registered_date: new Date(2022, 2, 24),
    total: { amount: 8900, filing_frequency: 'month' },
  },
  {
    title: 'DATEV export',
    country: 'IT',
    registered_date: new Date(2022, 2, 24),
    total: { amount: 1900, filing_frequency: 'month' },
  },
  {
    title: 'Instrastat filing',
    country: 'IT',
    registered_date: new Date(2022, 2, 24),
    total: { amount: 29900, filing_frequency: 'month' },
  },
  {
    title: 'Fiscal Representative',
    country: 'FR',
    registered_date: new Date(2022, 2, 24),
    total: { amount: 1900, filing_frequency: 'month' },
  },
];

export default function ReccuringTab() {
  const { t } = useTranslation();
  return (
    <div>
      <div className='Text--20 fw-800'>{t('Local filing')}</div>
      <Table<LocalFilingItem>
        columns={getLocalFilingColumns(t)}
        data={LOCAL_FILING_ITEMS}
        className='Table--SingleItemTab px-4 pb-3'
      />
      {OTHER_DETAILS.map((d, i) => (
        <div key={d.title}>
          <div className='SingleItemTab__separator mx-n4' />
          <div className='Text--20 fw-800 pt-3 mb-2'>{t(d.title)}</div>
          {i === 0 && (
            <div className='d-grid SingleItemTab__grid--reccuring pb-2 mb-2 border-bottom Text--gray'>
              <div>{t('Country')}</div>
              <div>{t('Filing period')}</div>
              <div>{t('Price')}</div>
            </div>
          )}
          <div className='d-grid SingleItemTab__grid--reccuring pb-4'>
            <div>
              <CountryLabel country={d.country} />
            </div>
            <div>
              {t('since')} {formatDate(d.registered_date, 'dd.MM.yyyy')}
            </div>
            <div>
              {formatNumber(d.total.amount / 100, {
                currency: 'eur',
              })}{' '}
              / {t('month')}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
